import { FC, memo, useMemo } from "react";
import { useGetResourcesQuery } from "graphql/__generated__/hooks";
import { Resource } from "types/resource";
import { ListWithEntitySelector } from "components/ListWithEntitySelector";

type RelevantResourcesLinkProps = {
  relevantResourceLinks: Resource[];
  onChange: (value: Resource[]) => void;
};

export const RelevantResourcesLinkComponent: FC<RelevantResourcesLinkProps> = ({
  relevantResourceLinks,
  onChange,
}) => {
  const { data } = useGetResourcesQuery();

  const resources = useMemo(() => {
    return (data?.resource as Resource[]) || [];
  }, [data]);

  return (
    <ListWithEntitySelector
      label="Relevant Resource Link"
      elements={relevantResourceLinks}
      onChangeElements={(selected) => onChange(selected)}
      idField={"resource_id"}
      entityName={"Resource Link"}
      entityList={resources}
    />
  );
};

export const RelevantResourcesLink = memo(RelevantResourcesLinkComponent);
